import { dataHooks } from '../../../../../libs/dataHooks';

export const widgetCarouselDotsDataHooks = dataHooks<{
  dot: { index: number; isActive: boolean };
}>('widget');
